// ADDENDUM 10 (E16) — las fechas de la ficha llegan como INSTANTE y el navegador decide el día.
//
// Un solo sitio donde se deriva el día, a propósito: la cabecera, el campo editable y el cuerpo que
// se guarda tienen que salir del MISMO cálculo, porque el defecto que este addendum quita era
// justamente el de dos representaciones del mismo dato discrepando en un día. Si cada pantalla
// derivara el día por su cuenta, coincidirían por cuidado y no por construcción — hasta que alguien
// tocara una de las dos.
//
// El día se toma SIEMPRE en la zona del navegador (`getFullYear`/`getMonth`/`getDate`, no las
// variantes UTC): `2026-06-11T22:00:00Z` es medianoche en la zona de la fábrica y su día es el 12.
// Recortar por la `T` daría el 11 — el defecto original, entrando por la misma puerta.

const ISO_DAY = /^\d{4}-\d{2}-\d{2}$/

const pad = (value) => String(value).padStart(2, '0')

/**
 * Día `YYYY-MM-DD` de un instante, en la zona del navegador.
 *
 * Una cadena que YA es un día se devuelve tal cual, y no es un atajo: `new Date('2026-06-12')` se
 * interpreta como medianoche UTC, así que en una zona al oeste de Greenwich el día local sería el
 * 11. Ese es exactamente el desplazamiento "por el otro lado" contra el que avisa el punto 3 del
 * addendum, y pasa al releer lo que el propio usuario acaba de escribir en el campo.
 */
export const localDayOf = (value) => {
  if (!value) return ''
  if (typeof value === 'string' && ISO_DAY.test(value)) return value
  const instant = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(instant.getTime())) return typeof value === 'string' ? value : ''
  return `${instant.getFullYear()}-${pad(instant.getMonth() + 1)}-${pad(instant.getDate())}`
}

// S450 — el PO retira el truncado a día para las fechas editables de General: ahora se ven y se
// eligen con día Y HORA, el mismo `DateTimePicker` que ya usa el listado. Estas dos funciones son
// las que sustituyen a `localDayOf`/`dayValueOf` en ese camino — el día se sigue derivando para
// quien todavía lo necesite (nadie, tras este cambio, pero la función no se retira: la prueba
// directamente en `detailDates.test.js` sigue viva).

/**
 * El instante, como objeto `Date`, que el `DateTimePicker` (adaptador date-fns) espera en su prop
 * `value`. `null` para lo que no es una fecha interpretable — nunca `Invalid Date`, que el picker
 * pintaría como una fecha rota en vez de un campo vacío.
 */
export const toDateTimeValue = (value) => {
  if (!value) return null
  const instant = value instanceof Date ? value : new Date(value)
  return Number.isNaN(instant.getTime()) ? null : instant
}

/**
 * El instante elegido, serializado como ISO — SIN truncar a medianoche. Es lo que ahora viaja en
 * el cuerpo de guardado para `targetDate`/`deliveryDate`/`expirationDate` (addendum 10 revocado por
 * S450: antes se recortaba aquí mismo con `localDayOf`).
 */
export const toInstantIso = (value) => {
  if (value === null || value === undefined || value === '') return null
  const instant = value instanceof Date ? value : new Date(value)
  return Number.isNaN(instant.getTime()) ? null : instant.toISOString()
}
